<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="group_2 flex-col">
        <headerMask/>
       
      </div>
      <div class="image-wrapper_6 flex-row justify-between">
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG09cb983dcfff56fe852a4569159ebb64.png'"
        />
        <img
          class="image_3"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNGad465eb1db4df41e085b8b25c44b203d.png'"
        />
      </div>
      <span class="text_77">开运动处方找以动就够了</span>
      <div class="group_4 flex-col" style="cursor: pointer;" @click="toTools">
        <div class="text-wrapper_1 flex-col"><span class="text_9">免费试用</span></div>
      </div>
     
    </div>
    <div class="group_s18 flex-col">
      <div class="text-group_s24 flex-col justify-between">
        <div class="text-wrapper_s31">
          <span class="text_s95">通用医疗</span>
          <span class="text_s96">运动处方工作站</span>
        </div>
        <span class="text_s97">适用大型医院、机构、养老产业</span>
      </div>
      <div @click="toSt1" style="cursor: pointer;" class="text-wrapper_s32 flex-col"><span class="text_s98">了解更多</span></div>
      <img
        class="image_s43"
        referrerpolicy="no-referrer"
        v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNGa6b5967423fe32699f7fb7d0c198fd2a.png'"
      />
    </div>
    <div class="group_5 flex-col">
      <div class="text-wrapper_300">
        <span class="text_180">智能</span>
        <span class="text_190">运动处方一体机</span>
      </div>
      <span class="text_11">适用大型医院、机构、养老产业</span>
      <div @click="toSt" style="cursor: pointer;" class="group_6 flex-col">
        <div class="text-wrapper_2 flex-col"><span class="text_12">了解更多</span></div>
      </div>
    </div>
    <div class="group_7 flex-col">
      <div class="text-group_20 flex-col justify-between">
        <span class="text_13">便携式工作站</span>
        <span class="text_14">适用大型社区、康复中心、健康管理机构</span>
      </div>
      <div  style="cursor: pointer;" class="text-wrapper_3 flex-col"><span class="text_15">了解更多</span></div>
    </div>
    <div class="group_8 flex-col">
      <div  class="text-group_21 flex-col justify-between">
        <span class="text_16">web端康复助手</span>
        <span class="text_17">个人康复治疗师、健身房、私人康复工作室</span>
      </div>
      <div  style="cursor: pointer;" @click="toSt" class="text-wrapper_4 flex-col"><span class="text_18">了解更多</span></div>
    </div>

    <div class="block_1 flex-col">


 
      <div class="text-wrapper_w15">
        <span class="text_w38">方案中独特的</span>
        <span class="text_w39">产品</span>
      </div>
      <div class="image-wrapper_w3 flex-row justify-between">
        <img
          class="image_w19"
          @click="arrowClick('prev','0')"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG77f76164ffac0b0f16b905555e737cb1.png'"
        />

        <el-carousel  class="image_w20" height="100%" :autoplay="true" arrow="never" indicator-position="none" ref="cardShow"  @change="imgsChange">
          <el-carousel-item v-for="(item, index) in imgs" :key="index" :style="'background:url('+item+') no-repeat center'">
   
          </el-carousel-item>
        </el-carousel>
    
        <img
          class="image_w21"
          @click="arrowClick('next','0')"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG7eb12c3aae8f3a98354f4c035fa6a95b.png'"
        />
      </div>
      <span class="text_w40">{{ currName }}</span>
      <div class="text-wrapper_w16">
        <span class="text_w41">支持链接的</span>
        <span class="text_w42">产品</span>
      </div>
      <div class="box_w8 flex-row justify-between">
        <img
          class="image_w22"
          @click="arrowClick('prev','1')"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG77f76164ffac0b0f16b905555e737cb1.png'"
        />
        <div class="image-wrapper_w4 flex-col">

          <el-carousel  class="image_w23" height="100%" :autoplay="true" arrow="never" indicator-position="none" ref="cardShow1" @change="imgs1Change">
          <el-carousel-item v-for="(item, index) in imgs1" :key="index" :style="'background:url('+item+') no-repeat center'">
   
          </el-carousel-item>
        </el-carousel>
     
        </div>
        <img
          class="image_w24"
          @click="arrowClick('next','1')"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG7eb12c3aae8f3a98354f4c035fa6a95b.png'"
        />
      </div>
      <span class="text_w43">{{currName1}}</span>
      
      <div class="group_13 flex-col">
        <div class="text-wrapper_16">
          <span class="text_40">著名三甲</span>
          <span class="text_41">医院专科和私立康复</span>
          <span class="text_42">机构的选择</span>
        </div>
        <div class="image-wrapper_8 flex-row justify-between">
          <img
            class="image_19"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG1794e752389f3226c85d95c381f8d3b4.png'"
          />
          <img
            class="image_20"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNGa98c8059fce28fb99b7d4859de05bae6.png'"
          />
          <img
            class="image_21"
            referrerpolicy="no-referrer"
            v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG0d3155482386ab4c828b2e9d733ddd6b.png'"
          />
        </div>
        <div class="text-wrapper_28 flex-row justify-between">
          <span class="text_43">中日友好医院</span>
          <span class="text_44">北京大兴清源路街道养老社区</span>
          <span class="text_45">北京聚陆医疗</span>
        </div>
      </div>
      <div class="text-wrapper_18">
        <span class="text_46">运动处方</span>
        <span class="text_47">数据参考来源</span>
      </div>
      <div class="image-wrapper_9 flex-row justify-between">
        <img
          class="image_22"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG094c8a0b91b09f5dbfbdab89afc886fe.png'"
        />
        <img
          class="image_23"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNGc9197906aeff173ae861090ce8f65f5a.png'"
        />
        <img
          class="image_24"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG469a7ccfe6af7daa095a79d9be106075.png'"
        />
      </div>
      <div class="text-wrapper_29 flex-row">
        <span class="text_48">美国运动医学会</span>
        <span class="text_49">美国物理治疗师协会</span>
        <span class="text_50">世界物理治疗师协会</span>
      </div>

      <div class="group_17 flex-col"></div>
  
    </div>
    <div class="group_21 flex-col">
      <div class="image-wrapper_10 flex-row justify-between">
        <img
          class="label_2"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNGcdff11e08207d5782e9198c64898272b.png'"
        />
        <img
          class="image_27"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG62502f655eccbcec3e5735ba277fd3ba.png'"
        />
      </div>
     <footerMask/>
    </div>
    <div class="group_23 flex-col">
      <div class="box_9 flex-row justify-between">
        <img
          class="image_29"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG865f2cd1786fc2a8bc8fb883d4c6af01.png'"
        />
        <div class="box_6 flex-col"></div>
        <img
          class="image_30"
          referrerpolicy="no-referrer"
          v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG09c7b252d09de66d4126ddc837fb7b30.png'"
        />
        <span class="text_73">四大特点</span>
      </div>
      <div class="box_10 flex-row justify-between">
        <div class="section_1 flex-col">
          <div class="image-text_23 flex-col justify-between">
            <img
              class="image_31"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG23a3f3cbaa5c5cf5abfdfded555b02b9.png'"
            />
            <span class="text-group_16">开具运动处方及教育</span>
          </div>
          <span class="text_74">我们提供运动处方工具软件和平台，全面辅助您开具运动处方，增加患者使用效果和粘性。</span>
        </div>
        <div class="section_2 flex-col">
          <div class="image-text_24 flex-col justify-between">
            <img
              class="image_32"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG98fd649ed6478278a07d315c051ca4ab.png'"
            />
            <span class="text-group_17">经过临床验证</span>
          </div>
          <span class="paragraph_11">
            产品有效性经过临床实验，证明可以增加康复效果和用户粘性。
            <br />
          </span>
        </div>
        <div class="section_3 flex-col">
          <div class="image-text_25 flex-col justify-between">
            <img
              class="image_33"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG300885673b2e57d8f77e31fd47eaf063.png'"
            />
            <span class="text-group_18">最新运动处方知识</span>
          </div>
          <span class="text_75">核心运动处方知识库根据循证医学体系建立，收集最新运动康复相关专业知识。</span>
        </div>
        <div class="section_4 flex-row">
          <div class="image-text_26 flex-col justify-between">
            <img
              class="image_34"
              referrerpolicy="no-referrer"
              v-lazy="'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG9212e6b20a72bb4431431658bfd35e3a.png'"
            />
            <div class="text-group_26 flex-col justify-between">
              <span class="paragraph_12">
                智慧化运动处方
                <br />
                “整屋定制”
              </span>
              <span class="text_76">
                开运动处方，提供一站式的基于物联网康复设备的解决方案，如可定制的系统及设备选择，场地及服务流程的梳理等。
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import headerMask from "../../components/header";
import footerMask from "../../components/footer";
export default {
  
  components: {
    headerMask,
    footerMask
  },

  data() {
    return {
      loopData0: [
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG3e8176820a0259d93d6d60540e595da7.png',
          lanhutext0: '康复',
          lanhutext1: '评估',
          lanhutext2: '助手'
        },
        {
          lanhuimage0: 'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG8a69054cc4d57ccc69f029fced903d73.png',
          lanhutext0: '康复',
          lanhutext1: '处方',
          lanhutext2: '助手'
        }
      ],
      imgs: [
        'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNG1d513532e10c40e5daaa7f4843e960c1.png',
        'https://web-cdn.ktangtang.com/official-website/homepage/home1.png',
        'https://web-cdn.ktangtang.com/official-website/homepage/home2.png',
        'https://web-cdn.ktangtang.com/official-website/homepage/home3.png',
    
       ],
       imgs1: [
        'https://web-cdn.ktangtang.com/official-website/homepage/FigmaDDSSlicePNGec0eadba495888a3593392acf5f1ba48.png',
        'https://web-cdn.ktangtang.com/official-website/homepage/home11.png',
        'https://web-cdn.ktangtang.com/official-website/homepage/home12.png',
        'https://web-cdn.ktangtang.com/official-website/homepage/home13.png',
        'https://web-cdn.ktangtang.com/official-website/homepage/home14.png',
    
       ],
       imgsName: ['以动物联网护心控糖功率车','以动物联网护心控糖向心功率车','以动中老年体适能一体机','主动有氧被动离心功率车'],
       imgs1Name: ['心率墙','全身有氧训练机（侧摆臂）IC7006','全⾝肌⼒训练机 IC7008','全⾝脑部肢体协调训练机 IC7009', '全⾝线性有氧健⾝⻋ IC7007'],
       currName: '以动物联网护心控糖功率车',
       currName1: '心率墙',
      constants: {}
    };
  },
  async mounted() {
    
    let weight = window.screen.width
    console.log(weight, 'ddddddddddddd')
    if(weight < 1200){
      this.$router.push({path: '/home'})
    }
  
  },
  methods: {

    toTools(){
          window.location.href=  'https://yd-tool.ktangtang.com/login'
    },
    toSt (){
      this.$router.push({path: '/e26'})
    },  
    toSt1 (){
      this.$router.push({path: '/workstation'})
    },  
    imgsChange(e){
      this.currName = this.imgsName[e]
    },
    imgs1Change(e){
      this.currName1 = this.imgs1Name[e]
    },
    arrowClick(val, bu) {
      let info = ""
      if(bu === '0'){
        info = this.$refs.cardShow
      }else{
        info = this.$refs.cardShow1
      }
      
      if(val === 'next' && info !=="") {
        info.next()
      } else {
       info.prev()
      }
    },

  }
};
</script>
<style scoped lang="css" src="./assets/index.rem.css" />